/* import { withAuthenticationRequired } from "@auth0/auth0-react"; */
import React, { useContext, useEffect, useState } from "react";
import Loading from "../../../components/Loading";
import { api } from "../../../services/api";
import {
  Alert,
  Input,
} from "reactstrap";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { PaginatorContext } from "../../../providers/Paginator";
import VolverButton from "../../../components/VolverButton";
import { useTranslation } from "react-i18next";
import { toast, Bounce } from 'react-toastify';
import { Button, Container, Table, TablePagination, TableBody, Paper, TableContainer, TableHead, TableRow, TableCell, CircularProgress, IconButton, Menu, MenuItem, ListItemIcon, ListItemText, TextField } from "@mui/material";
import moment from "moment";
import withAuthenticationRequired from "../../../components/ProtectedRoutes/withAuthenticationRequired";
import { DownloadOutlined, FileDownloadOutlined, MoreVert, Search } from "@mui/icons-material";

export const Ventas = () => {
  const history = useHistory();
  const param = useParams();
  const [t] = useTranslation("global");
  const [loading, setLoading] = useState();

  const {
    query,
    setQuery,
    totalLength,
    setTotalLength,
    currentPage,
    setCurrentPage,
    pageSize,
    setPageSize,
  } = useContext(PaginatorContext);

  const [ventas, setVentas] = useState([]); // Almacenamiento de los registros
  const [showSearch, setShowSearch] = useState();

  useEffect(() => {
    const callApi = async (id) => {
      setLoading(true);

      try {
        const response = await api.ventas.getAll(
          id,
          query,
          pageSize,
          currentPage
        );

        if (response.status === "success") {
          setVentas(response.data.ventas);
          setTotalLength(response.data.totalDataSize);
        }
      } catch (error) {
        toast.error(error.message, {
          position: "top-center",
          autoClose: 4000,
        });
      } finally {
        setLoading(false);
      }
    };

    callApi(param.id);
  }, [param.id, query, pageSize, currentPage, setTotalLength]);

  const handleDescargarReporteVentas = async () => {
    try {
      setLoading(true);

      const blob = await api.reporte.downloadReporteVentas(param.id);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      const fechaActual = new Date().toISOString().split('T')[0];
      link.download = `reporte_ventas_${fechaActual}.pdf`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

      setToast({
        open: true,
        message: 'La descarga ha comenzado correctamente',
        severity: 'success'
      });
    } catch (error) {
      console.error('Error al descargar el reporte:', error);
      setToast({
        open: true,
        message: 'Error al descargar el reporte: ' + (error.message || 'Error desconocido'),
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };
  const handleDescargarReporteDetalle = async () => {
    try {
      setLoading(true);

      const blob = await api.reporte.downloadReporteDetalle(param.id);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      const fechaActual = new Date().toISOString().split('T')[0];
      link.download = `reporte_detalle_${fechaActual}.pdf`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

      setToast({
        open: true,
        message: 'La descarga ha comenzado correctamente',
        severity: 'success'
      });
    } catch (error) {
      console.error('Error al descargar el reporte:', error);
      setToast({
        open: true,
        message: 'Error al descargar el reporte: ' + (error.message || 'Error desconocido'),
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDescargarReporteDetalleCaja = async () => {
    try {
      setLoading(true);

      const blob = await api.reporte.downloadReporteDetalleCaja(param.id);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      const fechaActual = new Date().toISOString().split('T')[0];
      link.download = `reporte_caja_${fechaActual}.pdf`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

      setToast({
        open: true,
        message: 'La descarga ha comenzado correctamente',
        severity: 'success'
      });
    } catch (error) {
      console.error('Error al descargar el reporte:', error);
      setToast({
        open: true,
        message: 'Error al descargar el reporte: ' + (error.message || 'Error desconocido'),
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Resetear pag cuando cambie la query
    if (query.length > 0) {
      setCurrentPage(0);
    }
  }, [query, setCurrentPage]);

  const handleSearchChange = (e) => {
    setQuery(e.target.value);
    setCurrentPage(0);
  };

  // Manejar el cambio de página
  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  // Manejar el cambio de tamaño de página
  const handleChangeRowsPerPage = (event) => {
    setPageSize(parseInt(event.target.value, 10));
    setCurrentPage(0); // Reiniciar la página al cambiar el tamaño
  };

  const handleRowClick = (venta) => {
    history.push(`/eventos/${param.id}/ventas/${venta.id}`);
  };

  //BUSQUEDA
  const handleToggleSearch = () => {
    setShowSearch(!showSearch);
    setQuery("");
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElID, setAnchorElID] = useState(null);
  const openSeeMore = Boolean(anchorEl);

  const handleClickSeeMore = (e) => {
    e.stopPropagation()
    setAnchorEl(e.currentTarget)
    setAnchorElID(e.currentTarget.id)
  }

  const handleCloseSeeMore = (e) => {
    e.stopPropagation()
    setAnchorEl(null)
    setAnchorElID(null)
  }

  const [toast, setToast] = useState({
    open: false,
    message: '',
    severity: "success"
  });

  const handleDescargarReporteParticipantes = async () => {
    try {
      setLoading(true);

      const blob = await api.reporte.downloadReporteParticipantes(param.id);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      const fechaActual = new Date().toISOString().split('T')[0];
      link.download = `reporte_participantes_${fechaActual}.pdf`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

      setToast({
        open: true,
        message: 'La descarga ha comenzado correctamente',
        severity: 'success'
      });

    } catch (error) {
      console.error('Error al descargar el reporte:', error);

      setToast({
        open: true,
        message: 'Error al descargar el reporte: ' + (error.message || 'Error desconocido'),
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <form onSubmit={(e) => e.preventDefault()} className="d-flex justify-content-end">
        <div className="w-100 d-flex gap-2">
          <TextField
            id="exampleSearch"
            name="q"
            value={query}
            onChange={handleSearchChange}
            placeholder="Buscar por ID, Referencia o Email"
            type="search"
            variant="outlined"
            size="small"
            sx={{
              width: "40%",
              fontFamily: "Bricolage Grotesque",
              mb: 2,
              '& .MuiInputBase-input-MuiOutlinedInput-input': {
                fontFamily: "Bricolage Grotesque",
              },
              '& label.Mui-focused': {
                color: '#5656FF',
                fontFamily: "Bricolage Grotesque"
              },
              '& .MuiOutlinedInput-root': {
                height: "40px",
                '& fieldset': {
                  borderColor: '#B2BAC2',
                },
                '&:hover fieldset': {
                  borderColor: '#5656ff',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#5656ff',
                },
              }
            }}
            InputProps={{
              endAdornment: (
                <IconButton
                  type="submit"
                  size="small"
                  sx={{ marginRight: "-8px" }}
                >
                  <Search />
                </IconButton>
              ),
            }}
          />
        </div>
        <IconButton
          aria-label="see more"
          id={param.id}
          aria-controls={openSeeMore ? 'long-menu' : undefined}
          aria-expanded={openSeeMore ? 'true' : undefined}
          aria-haspopup="true"
          onClick={handleClickSeeMore}
          sx={{ p: 0 }}
          className="ms-auto"
        >
          <MoreVert />
        </IconButton>
        <Menu
          id={param.id}
          aria-label="report"
          anchorEl={anchorEl}
          open={param.id === anchorEl?.id}
          onClose={handleCloseSeeMore}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >

          <MenuItem onClick={handleDescargarReporteVentas}>
            <ListItemIcon>
              {loading ? (
                <CircularProgress size={24} />
              ) : (
                <FileDownloadOutlined sx={{ color: "#5656FF" }} />
              )}
            </ListItemIcon>
            {loading ? (
              <ListItemText>Descargando reporte..</ListItemText>
            ) : (
              <ListItemText>Reporte ventas</ListItemText>
            )}
          </MenuItem>
        </Menu>
      </form>

      <TableContainer component={Paper} className="mt-3 table-responsive">
        <Table aria-label="simple table">
          <TableHead sx={{ backgroundColor: "#E6E6FF" }}>
            <TableRow sx={{ borderColor: "#E6E6FF", textAlign: "center" }}>
              <TableCell align="center" sx={{ fontSize: "14px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque", }}>#</TableCell>
              <TableCell align="center" sx={{ fontSize: "14px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque", }}>Referencia</TableCell>
              <TableCell align="center" sx={{ fontSize: "14px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque", }}>Email</TableCell>
              <TableCell align="center" sx={{ fontSize: "14px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque", }}>{t("sales.payDate")}</TableCell>
              {/* <TableCell align="center">N° Comprobante</TableCell> */}
              <TableCell align="center" sx={{ fontSize: "14px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque", }}>Total</TableCell>
              <TableCell align="center" sx={{ fontSize: "14px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque", }}>Medio de pago</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <CircularProgress color="primary" />
                </TableCell>
              </TableRow>
            ) : (
              ventas ? (
                ventas.map((venta) => (
                  <TableRow
                    key={venta.id}
                    onClick={venta.atendido ? () => handleRowClick(venta) : null}
                    style={venta.atendido && { cursor: "pointer" }}
                    hover
                  >
                    <TableCell component="th" scope="row" className="fw-medium" sx={{ fontFamily: "Bricolage Grotesque", }}>{venta.id}</TableCell>

                    <TableCell align="center" className="fw-medium" sx={{ fontFamily: "Bricolage Grotesque", }}>
                      {venta.external_reference}
                    </TableCell>
                    <TableCell className="fw-medium" sx={{ fontFamily: "Bricolage Grotesque" }} align="center">{venta.email}</TableCell>

                    <TableCell className="fw-medium" sx={{ fontFamily: "Bricolage Grotesque" }} align="center">
                      {moment.parseZone(venta.atendido).format("DD/MM/YY HH:mm")} hs.
                    </TableCell>

                    <TableCell align="center" className="fw-medium" sx={{ fontFamily: "Bricolage Grotesque", }}>
                      $ {venta.monto_total}
                    </TableCell>
                    <TableCell className="fw-medium" sx={{ fontFamily: "Bricolage Grotesque", }} align="center">{venta.metodo_pago}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6}>
                    <Alert color="secondary" className="m-0">
                      {t("sales.saleAlert")}
                    </Alert>
                  </TableCell>
                </TableRow>
              )
            )}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          className="d-flex justify-content-center"
          rowsPerPageOptions={[10, 25, 50]} // Opciones de tamaño de página
          count={totalLength} // Total de registros
          rowsPerPage={pageSize} // Tamaño de la página actual
          page={currentPage} // Página actual
          onPageChange={handleChangePage} // Evento de cambio de página
          onRowsPerPageChange={handleChangeRowsPerPage} // Evento de cambio de tamaño de página
          labelRowsPerPage="Registros p/página"
          showFirstButton
          showLastButton
        />
      </TableContainer>

    </Container>
  );
};

export default withAuthenticationRequired(Ventas, {
  onRedirecting: () => <Loading />,
});
